import script from "./XiamenProductComponents.vue?vue&type=script&setup=true&lang=js"
export * from "./XiamenProductComponents.vue?vue&type=script&setup=true&lang=js"

import "./XiamenProductComponents.vue?vue&type=style&index=0&id=95e17074&lang=less"

const __exports__ = script;

export default __exports__